import useDebounce from 'shared/composables/debounce';
import useLoggedInUserAccount from '@/composables/logged-in-user-account/logged-in-user-account';
import { authenticatedRoutes } from '@/router';
import { useRoute, useRouter } from 'vue-router';
import { watch } from 'vue';

export default function useRouteHealer() {
  const route = useRoute();
  const router = useRouter();
  const { loggedInUserAccount } = useLoggedInUserAccount();
  const { debounce } = useDebounce({ onBeforeUnmountCancel: true });

  const heal = (currentRoute, activeSlug) => {
    if (!currentRoute.name || !activeSlug) {
      return undefined;
    }

    const slug = activeSlug.slug;
    // Check if we are on a legacy route (unslugged)
    // In router.js, legacy routes are named `legacy-${route.name}`
    if (typeof currentRoute.name === 'string' && currentRoute.name.startsWith('legacy-')) {
      return {
        name: currentRoute.name.replace('legacy-', ''),
        params: { ...currentRoute.params, tenantSlug: slug },
        query: currentRoute.query,
      };
    }
    if (currentRoute.params.tenantSlug !== slug && authenticatedRoutes.some((route) => route.name === currentRoute.name)) {
      return {
        ...currentRoute,
        params: { ...currentRoute.params, tenantSlug: slug },
      };
    }
    return undefined;
  };

  watch(
    [() => route.name, () => loggedInUserAccount.value?.activeSlug],
    ([_, activeSlug]) => {
      const modifiedRoute = heal(route, activeSlug);
      if (modifiedRoute) {
        debounce(() => router.replace(modifiedRoute), 100);
      }
    },
    { immediate: true },
  );
}
